/**
 * @param  {[]String} arrayOfAvatarsUrls
 * @return {?String}
 */

export default function computeOptimalBaseAvatarURL(arrayOfAvatarsUrls: string[]) {
  // just one? we don't need to do anything
  if (arrayOfAvatarsUrls.length <= 1) {
    return null;
  }

  const PSTATIC_CLASSDOJO_REGEX = /(?:(?:https?:)?\/\/)pstatic\.classdojo\.com/;

  const canOptimize = arrayOfAvatarsUrls.every((url) => PSTATIC_CLASSDOJO_REGEX.test(url));

  if (canOptimize) {
    const matches = arrayOfAvatarsUrls[0].match(PSTATIC_CLASSDOJO_REGEX);
    return matches?.[0];
  }

  return null;
}
